import EnvironmentBanner from '../headers/EnvironmentBanner';
import { ReactElement } from 'react';
import PageHeader from '../headers/PageHeader';
import usePageHeader from '../../hooks/navigation/usePageHeader';

interface Props {
  children: ReactElement;
  header?: ReactElement;
  headerClassName?: string;
  headerFooter?: ReactElement;
  className?: string;
}

const PageLayout = (props: Props): ReactElement => {
  const { children, header, className, headerClassName, headerFooter } = props;
  const { showEnvBanner } = usePageHeader();

  return (
    <div className="min-h-screen">
      <div id="page-header" className={`sticky top-0 z-40 ${headerClassName ?? ''}`}>
        {showEnvBanner && <EnvironmentBanner />}
        {header ?? <PageHeader />}
        {headerFooter}
      </div>
      <div className={className}>{children}</div>
    </div>
  );
};

export default PageLayout;
